import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { LoginGuard } from './auth/login.guard';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LoaderService } from './components/loader/loader.service';
var $: any;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(e: KeyboardEvent) {
    if (e.key === 'F12') {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === "I") {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === "C") {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === "J") {
      return false;
    }
    if (e.ctrlKey && e.key == "U") {
      return false;
    }
    return true;
  }

  title = 'ui';
  showHeader: boolean;
  constructor(public loginGuard: LoginGuard, private router: Router, private activatedRoute: ActivatedRoute, private location: Location) {
    this.router.events.subscribe((event: any) => {
      if (event && event.url) {
        this.showHeader = ![
          '/landing',
          '/unauthorized',
          '/login',
          '/Home',
          '/login-issue',
          '',
          '/maintenance'
        ].includes(event.url);
      }
    });

    // document.addEventListener('contextmenu', function (e) {
    //   e.preventDefault();
    // });
  }
  shouldDisplayHeader(): boolean {
    const currentUrl = this.router.routerState.snapshot.url;

    const isLandingPage = currentUrl === '/landingpage';
    const isLoginPage = currentUrl === '/login';
    return !isLandingPage && !isLoginPage;
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnInit() {
    //  if( this.location.path() == '/login' ||  this.location.path() == '' || this.location.path() == '/Home'){
    //   this.path=false;
    //  }
    //  else{
    //   this.path=true;
    //  }

  }
  ngAfterViewInit() {
    // this.setPath();

  }
}
